(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ceramic-founder-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ceramic-founder-cart')) {
  let pending = false;
  customElements.define('ceramic-founder-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', () => this.add());
    }
    async add() {
      const button = this.querySelector('button');
      if (pending || button.disabled) return;
      pending = true;
      const buttons = [...document.querySelectorAll('ceramic-founder-cart button')];
      const states = buttons.map(item => item.disabled);
      buttons.forEach(item => item.disabled = true);
      button.setAttribute('aria-busy', 'true');
      const label = this.querySelector('[data-label]');
      const original = label.textContent;
      label.textContent = window.theme?.cartStrings?.adding || 'Adding…';
      const error = this.querySelector('[role="alert"]');
      error.hidden = true;
      let added = false;
      try {
        const drawer = document.getElementById('CartDrawer');
        if (!drawer || typeof drawer.show !== 'function') throw new Error('Cart is not ready. Please try again.');
        const section = drawer.getAttribute('data-section-id');
        const deposit = Number(this.dataset.deposit);
        const kit = Number(this.dataset.kit);
        if (!deposit || !kit || deposit === kit) throw new Error('This bundle is currently unavailable.');
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:[{id:deposit, quantity:1},{id:kit, quantity:1, parent_id:deposit, properties:{_visa_sizing_kit:'true'}}], sections:[section], sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add to cart. Please try again.');
        added = true;
        let html = result.sections?.[section];
        if (!html) {
          const refresh = await fetch(this.dataset.root + '?section_id=' + encodeURIComponent(section));
          if (!refresh.ok) throw new Error();
          html = await refresh.text();
        }
        const id = 'MiniCart-' + section;
        const updated = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
        const current = document.getElementById(id);
        if (!updated || !current) throw new Error();
        current.innerHTML = updated.innerHTML;
        drawer.show(button);
      } catch (cause) {
        error.textContent = added ? 'Added to cart. Please open your cart to view your items; do not add again.' : cause.message;
        error.hidden = false;
      } finally {
        pending = false;
        buttons.forEach((item, index) => item.disabled = states[index]);
        button.removeAttribute('aria-busy');
        label.textContent = original;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["visa-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('visa-size-guide')) {
  customElements.define('visa-size-guide',class extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();
      const opts={signal:this.controller.signal};
      const kitSteps=[...this.querySelectorAll('.visa-guide__kit-steps details')];
      kitSteps.forEach(step=>{
        step.querySelector('summary').addEventListener('click',()=>{
          if(!step.open)kitSteps.forEach(other=>{if(other!==step)other.open=false;});
        },opts);
        step.addEventListener('toggle',()=>{
          if(step.open)kitSteps.forEach(other=>{if(other!==step)other.open=false;});
        },opts);
      });
      this.dialog=this.querySelector('dialog');
      this.rows=JSON.parse(this.querySelector('[data-guide-rows]').textContent);
      this.scope=this.closest('.shopify-section')||this.parentElement;
      this.scope.querySelectorAll('[data-open-visa-guide]').forEach(button=>button.addEventListener('click',()=>{
        this.trigger=button;
        this.select('kit');
        this.dialog.showModal();
        this.dialog.scrollTop=0;
        this.querySelector('[data-guide-close]').focus();
      },opts));
      this.querySelector('[data-guide-close]').addEventListener('click',()=>this.dialog.close(),opts);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},opts);
      this.dialog.addEventListener('close',()=>this.trigger?.focus(),opts);
      this.querySelectorAll('[data-guide-tab]').forEach((button,index,all)=>{
        button.addEventListener('click',()=>this.select(button.dataset.guideTab),opts);
        button.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%all.length;
          if(event.key==='ArrowLeft')next=(index+all.length-1)%all.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=all.length-1;
          if(next===undefined)return;
          event.preventDefault();this.select(all[next].dataset.guideTab);all[next].focus();
        },opts);
      });
      this.querySelectorAll('[data-guide-accordion]').forEach(button=>button.addEventListener('click',()=>this.select(button.getAttribute('aria-expanded')==='true'?null:button.dataset.guideAccordion),opts));
      this.querySelectorAll('[data-guide-size]').forEach(button=>button.addEventListener('click',()=>{
        const row=this.rows.find(row=>row[0]===button.dataset.guideSize);
        if(!row)return;
        this.querySelectorAll('[data-guide-size]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        this.querySelectorAll('[data-guide-value]').forEach(el=>el.textContent=row[Number(el.dataset.guideValue)]);
      },opts));
      this.media=matchMedia('(max-width:767px)');
      this.media.addEventListener('change',()=>{this.select(this.active||'kit');},opts);
      this.select('kit');
    }
    select(key) {
      this.active=key;
      this.querySelectorAll('[data-guide-tab]').forEach(b=>{const active=b.dataset.guideTab===key;b.setAttribute('aria-selected',String(active));b.tabIndex=active?0:-1;});
      this.querySelectorAll('[data-guide-accordion]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.guideAccordion===key)));
      this.querySelectorAll('[data-guide-panel]').forEach(p=>{p.hidden=p.dataset.guidePanel!==key;p.setAttribute('role',this.media.matches?'region':'tabpanel');});
    }
    disconnectedCallback() { this.dialog?.close();this.controller?.abort();this.controller=null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
